"use client";

// packages/react/collapsible/src/Collapsible.tsx
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["__scopeCollapsible", "open", "defaultOpen", "disabled", "onOpenChange"],
  _excluded2 = ["__scopeCollapsible"],
  _excluded3 = ["forceMount"],
  _excluded4 = ["__scopeCollapsible", "present", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import * as React from "react";
import { composeEventHandlers } from "@radix-ui/primitive";
import { createContextScope } from "@radix-ui/react-context";
import { useControllableState } from "@radix-ui/react-use-controllable-state";
import { useLayoutEffect } from "@radix-ui/react-use-layout-effect";
import { useComposedRefs } from "@radix-ui/react-compose-refs";
import { Primitive } from "@radix-ui/react-primitive";
import { Presence } from "@radix-ui/react-presence";
import { useId } from "@radix-ui/react-id";
import { jsx } from "react/jsx-runtime";
var COLLAPSIBLE_NAME = "Collapsible";
var _createContextScope = createContextScope(COLLAPSIBLE_NAME),
  _createContextScope2 = _slicedToArray(_createContextScope, 2),
  createCollapsibleContext = _createContextScope2[0],
  createCollapsibleScope = _createContextScope2[1];
var _createCollapsibleCon = createCollapsibleContext(COLLAPSIBLE_NAME),
  _createCollapsibleCon2 = _slicedToArray(_createCollapsibleCon, 2),
  CollapsibleProvider = _createCollapsibleCon2[0],
  useCollapsibleContext = _createCollapsibleCon2[1];
var Collapsible = /*#__PURE__*/React.forwardRef(function (props, forwardedRef) {
  var __scopeCollapsible = props.__scopeCollapsible,
    openProp = props.open,
    defaultOpen = props.defaultOpen,
    disabled = props.disabled,
    onOpenChange = props.onOpenChange,
    collapsibleProps = _objectWithoutProperties(props, _excluded);
  var _useControllableState = useControllableState({
      prop: openProp,
      defaultProp: defaultOpen,
      onChange: onOpenChange
    }),
    _useControllableState2 = _slicedToArray(_useControllableState, 2),
    _useControllableState3 = _useControllableState2[0],
    open = _useControllableState3 === void 0 ? false : _useControllableState3,
    setOpen = _useControllableState2[1];
  return /* @__PURE__ */jsx(CollapsibleProvider, {
    scope: __scopeCollapsible,
    disabled: disabled,
    contentId: useId(),
    open: open,
    onOpenToggle: React.useCallback(function () {
      return setOpen(function (prevOpen) {
        return !prevOpen;
      });
    }, [setOpen]),
    children: /* @__PURE__ */jsx(Primitive.div, _objectSpread(_objectSpread({
      "data-state": getState(open),
      "data-disabled": disabled ? "" : void 0
    }, collapsibleProps), {}, {
      ref: forwardedRef
    }))
  });
});
Collapsible.displayName = COLLAPSIBLE_NAME;
var TRIGGER_NAME = "CollapsibleTrigger";
var CollapsibleTrigger = /*#__PURE__*/React.forwardRef(function (props, forwardedRef) {
  var __scopeCollapsible = props.__scopeCollapsible,
    triggerProps = _objectWithoutProperties(props, _excluded2);
  var context = useCollapsibleContext(TRIGGER_NAME, __scopeCollapsible);
  return /* @__PURE__ */jsx(Primitive.button, _objectSpread(_objectSpread({
    type: "button",
    "aria-controls": context.contentId,
    "aria-expanded": context.open || false,
    "data-state": getState(context.open),
    "data-disabled": context.disabled ? "" : void 0,
    disabled: context.disabled
  }, triggerProps), {}, {
    ref: forwardedRef,
    onClick: composeEventHandlers(props.onClick, context.onOpenToggle)
  }));
});
CollapsibleTrigger.displayName = TRIGGER_NAME;
var CONTENT_NAME = "CollapsibleContent";
var CollapsibleContent = /*#__PURE__*/React.forwardRef(function (props, forwardedRef) {
  var forceMount = props.forceMount,
    contentProps = _objectWithoutProperties(props, _excluded3);
  var context = useCollapsibleContext(CONTENT_NAME, props.__scopeCollapsible);
  return /* @__PURE__ */jsx(Presence, {
    present: forceMount || context.open,
    children: function children(_ref) {
      var present = _ref.present;
      return /* @__PURE__ */jsx(CollapsibleContentImpl, _objectSpread(_objectSpread({}, contentProps), {}, {
        ref: forwardedRef,
        present: present
      }));
    }
  });
});
CollapsibleContent.displayName = CONTENT_NAME;
var CollapsibleContentImpl = /*#__PURE__*/React.forwardRef(function (props, forwardedRef) {
  var __scopeCollapsible = props.__scopeCollapsible,
    present = props.present,
    children = props.children,
    contentProps = _objectWithoutProperties(props, _excluded4);
  var context = useCollapsibleContext(CONTENT_NAME, __scopeCollapsible);
  var _React$useState = React.useState(present),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isPresent = _React$useState2[0],
    setIsPresent = _React$useState2[1];
  var ref = React.useRef(null);
  var composedRefs = useComposedRefs(forwardedRef, ref);
  var heightRef = React.useRef(0);
  var height = heightRef.current;
  var widthRef = React.useRef(0);
  var width = widthRef.current;
  var isOpen = context.open || isPresent;
  var isMountAnimationPreventedRef = React.useRef(isOpen);
  var originalStylesRef = React.useRef();
  React.useEffect(function () {
    var rAF = requestAnimationFrame(function () {
      return isMountAnimationPreventedRef.current = false;
    });
    return function () {
      return cancelAnimationFrame(rAF);
    };
  }, []);
  useLayoutEffect(function () {
    var node = ref.current;
    if (node) {
      originalStylesRef.current = originalStylesRef.current || {
        transitionDuration: node.style.transitionDuration,
        animationName: node.style.animationName
      };
      node.style.transitionDuration = "0s";
      node.style.animationName = "none";
      var rect = node.getBoundingClientRect();
      heightRef.current = rect.height;
      widthRef.current = rect.width;
      if (!isMountAnimationPreventedRef.current) {
        node.style.transitionDuration = originalStylesRef.current.transitionDuration;
        node.style.animationName = originalStylesRef.current.animationName;
      }
      setIsPresent(present);
    }
  }, [context.open, present]);
  return /* @__PURE__ */jsx(Primitive.div, _objectSpread(_objectSpread({
    "data-state": getState(context.open),
    "data-disabled": context.disabled ? "" : void 0,
    id: context.contentId,
    hidden: !isOpen
  }, contentProps), {}, {
    ref: composedRefs,
    style: _objectSpread(_defineProperty(_defineProperty({}, "--radix-collapsible-content-height", height ? "".concat(height, "px") : void 0), "--radix-collapsible-content-width", width ? "".concat(width, "px") : void 0), props.style),
    children: isOpen && children
  }));
});
function getState(open) {
  return open ? "open" : "closed";
}
var Root = Collapsible;
var Trigger = CollapsibleTrigger;
var Content = CollapsibleContent;
export { Collapsible, CollapsibleContent, CollapsibleTrigger, Content, Root, Trigger, createCollapsibleScope };